import { formatDistanceToNow } from 'date-fns'
import { pt, enUS } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'
import { Circle } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { Notification } from '@/types/tenant'

interface NotificationItemProps {
  notification: Notification
  onMarkAsRead: () => void
}

export function NotificationItem({ notification, onMarkAsRead }: NotificationItemProps) {
  const { i18n } = useTranslation()
  const locale = i18n.language === 'pt' ? pt : enUS

  const timeAgo = formatDistanceToNow(new Date(notification.created_at), {
    addSuffix: true,
    locale,
  })

  return (
    <button
      className={cn(
        'w-full text-left px-4 py-3 hover:bg-muted/50 transition-colors',
        !notification.is_read && 'bg-muted/30'
      )}
      onClick={() => {
        if (!notification.is_read) onMarkAsRead()
      }}
    >
      <div className="flex items-start gap-2">
        {!notification.is_read && (
          <Circle className="mt-1.5 h-2 w-2 flex-shrink-0 fill-primary text-primary" />
        )}
        <div className={cn('flex-1 min-w-0', notification.is_read && 'ml-4')}>
          <p className="text-sm font-medium truncate">{notification.title}</p>
          {notification.message && (
            <p className="text-xs text-muted-foreground line-clamp-2 mt-0.5">
              {notification.message}
            </p>
          )}
          <p className="text-xs text-muted-foreground mt-1">{timeAgo}</p>
        </div>
      </div>
    </button>
  )
}
